import { SuggestedChanges, SectionSuggestedChanges, PlaybookContentType } from '../../admin/playbook/store/types';

export const isSectionChanges = (changes: SuggestedChanges): changes is SectionSuggestedChanges => changes.type === PlaybookContentType.SECTION;
